import React, { useState, useEffect,useContext } from 'react';
import { CCol, CButton, CModal, CModalHeader, CModalBody, CModalFooter, CCard } from '@coreui/react';
import { CChartPie } from '@coreui/react-chartjs';
import { pieChartOptions } from '../../utils/chartTheme';
import axios from 'axios';
import { AuthUserContext } from '../session/context';


const fhirEndpoint = 'https://fhir.mieros.cloud/fhir';

const ExpensePieChart = () => {
      const [chartData, setChartData] = useState(null);
      const [modal, setModal] = useState(false);
      const mieFToken = localStorage.getItem('mieFToken');
      const toggleModal = () => setModal(!modal);
      const { authUser, authMethod } = useContext(AuthUserContext);
      // Fetch ChargeItem data from FHIR endpoint
      useEffect(() => {
            const fetchChargeItems = async () => {
                  try {
                        const response = await axios.get(`${fhirEndpoint}/ChargeItem?identifier=https://fhir.mieros.cloud/fhir/ids|${authUser.uid}`, {
                              headers: {
                                    'Content-Type': 'application/fhir+json',
                                    'Authorization': `Bearer ${mieFToken}`,
                              },
                        });
                        const bundle = response.data;

                        if (bundle.entry && bundle.entry.length > 0) {
                              processFHIRData(bundle.entry);
                        } else {
                              setChartData(null); // No expenses found
                        }
                  } catch (error) {
                        console.error('Error fetching ChargeItem data:', error);
                  }
            };

            fetchChargeItems();
      }, []);

      const processFHIRData = (entries) => {
            const expenseData = entries.reduce((acc, entry) => {
                  const resource = entry.resource;
                  const description = resource?.code.text || 'Unknown';
                  const amount = resource?.quantity?.value || 0;

                  if (!acc[description]) {
                        acc[description] = 0;
                  }
                  acc[description] += amount;

                  return acc;
            }, {});

            const sortedCategories = Object.entries(expenseData)
                  .sort(([, a], [, b]) => b - a)
                  .slice(0, 10);

            const categories = sortedCategories.map(([category]) => category);
            const amounts = sortedCategories.map(([, amount]) => amount);

            setChartData({
                  labels: categories,
                  datasets: [
                        {
                              label: 'Top 10 Expenses',
                              data: amounts,
                              backgroundColor: [
                                    '#FF6384',
                                    '#36A2EB',
                                    '#FFCE56',
                                    '#FF9F40',
                                    '#4BC0C0',
                                    '#9966FF',
                                    '#FF6384',
                                    '#36A2EB',
                                    '#FFCE56',
                                    '#FF9F40',
                              ],
                        },
                  ],
            });
      };

      return (
            <CCard>
                  <div className="mb-2">Top 10 Expenses</div>
                  <CCol sm="10">
                        <div>
                              {chartData ? (
                                    <CChartPie data={chartData} options={pieChartOptions} />
                              ) : (
                                    <p>No expenses available.</p>
                              )}
                        </div>
                  </CCol>

                  <div style={{ position: 'absolute', right: 10, bottom: 10, display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <CButton
                              color="primary"
                              size="sm"
                              onClick={toggleModal}
                              style={{ fontSize: '20px', padding: '2px 6px' }}
                        >
                              View Larger
                        </CButton>
                  </div>

                  <CModal visible={modal} onClose={() => setModal(false)} size="lg"> 
                        <CModalHeader closeButton>Pie Chart - Larger View</CModalHeader>
                        <CModalBody>
                              {chartData && <CChartPie data={chartData} options={pieChartOptions} />}
                        </CModalBody>
                        <CModalFooter>
                              <CButton color="secondary" size="sm" onClick={toggleModal}>
                                    Close
                              </CButton>
                        </CModalFooter>
                  </CModal>
            </CCard>
      );
};

export default ExpensePieChart;


